import "./App.css";
import { useEffect, useState } from "react";
import SingleCard from "./components/SingleCard";

const cardImages = [
  { src: "/img/g1.jpeg", matched: false },
  { src: "/img/g2.png", matched: false },
  { src: "/img/g3.png", matched: false },
  { src: "/img/g4.png", matched: false },
  { src: "/img/g5.jpeg", matched: false },
  { src: "/img/g6.png", matched: false },
];

function App() {
  const [cards, setCards] = useState([]);
  const [turns, setTurns] = useState(0);
  const [choiceOne, setChoiceOne] = useState(null);
  const [choiceTwo, setChoiceTwo] = useState(null);
  const [disabled, setDisabled] = useState(false); // make sure you can't select multiple pairs - if player is a fast clicker

  // generate shuffled cards and update card state with shuffled cards
  const shuffle = () => {
    // duplicate to have 12 total images in new array
    const shuffledCards = [...cardImages, ...cardImages]
      // shuffle array
      .sort(() => Math.random() - 0.5)
      .map((card) => ({ ...card, id: Math.random() }));

    setCards(shuffledCards);
    setChoiceOne(null);
    setChoiceTwo(null);
    setTurns(0);
  };

  // update choiceone choice two depending on their choice
  const choice = (card) => {
    // null or false, evaluate setChoiceOne(card) - update choiceOne
    // if not null (has a value), update Choice Two
    choiceOne ? setChoiceTwo(card) : setChoiceOne(card);
  };

  // compare two cards
  // run whenever one of dependency changes [in sqr brackets]
  useEffect(() => {
    
    if (choiceOne && choiceTwo) {
      setDisabled(true);
      if (choiceOne.src === choiceTwo.src) {
        // match
        // update card state
        setCards((prevCards) => {
          return prevCards.map((card) => {
            if (card.src === choiceOne.src) {
              return { ...card, matched: true };
            } else {
              return card;
            }
          });
        });
        resetTurn();
      } else {
        // don't match
        setTimeout(() => resetTurn(), 1000)
      }
    }
  }, [choiceOne, choiceTwo]);

  console.log(cards);

  // run regardless if two cards match or not
  const resetTurn = () => {
    setDisabled(false);
    setChoiceOne(null);
    setChoiceTwo(null);
    setTurns((prevTurns) => prevTurns + 1);
  };

  // start new game automatically
  // call when component first mounts
  useEffect(() => {
    shuffle()
  }, [])

  return (
    <div className="App">
      <h1>We love UW geese &lt;3</h1>
      <button onClick={shuffle}>Let's see</button>

      <div className="card-grid">
        {cards.map((card) => (
          // card template extracted into components - makes it easier to apply logic to each card - later in project
          // pass in props
          <SingleCard
            key={card.id}
            c={card}
            choice={choice}
            flipped={card === choiceOne || card === choiceTwo || card.matched} // can be true given three circumstancess
            disabled={disabled}
          />
        ))}
      </div>
      <p>Turns: {turns}</p>
    </div>
  );
}

export default App;
